<template>
  <b-card no-body>
    <b-card-header class="align-items-baseline">
      <div class="w-100">
        <b-card-title>
          <slot name="title"></slot>
        </b-card-title>
        <b-form-group
          label="بازه‌ی تاریخ نرخ تبدیل سیستم"
          label-for="fromDateSchedule"
          class="mr-md-1 mt-2"
        >
          <b-input-group>
            <template #append>
              <b-input-group-text
                class="cursor-pointer"
                @click="clearDateRange"
              >
                <strong
                  :class="
                    dateRange && dateRange.length > 0 && dateRange[0]
                      ? 'text-danger'
                      : ''
                  "
                >
                  <feather-icon
                    :icon="
                      dateRange && dateRange.length > 0 && dateRange[0]
                        ? 'Trash2Icon'
                        : 'ClockIcon'
                    "
                    size="16"
                  />
                </strong>
              </b-input-group-text>
            </template>
            <b-form-input
              class="fromDateSchedule"
              id="fromDateSchedule"
              placeholder="بازه‌ی تاریخ را انتخاب کنید"
            ></b-form-input>
          </b-input-group>
          <date-picker
            range
            v-model="dateRange"
            :clearable="true"
            class="absolute"
            customInput=".fromDateSchedule"
            display-format="jYYYY/jMM/jDD"
            input-format="YYYY/MM/DD"
            format="YYYY-MM-DD"
          ></date-picker>
        </b-form-group>
        <hr class="my-1 w-100" />
        <div v-if="valueArray && valueArray.length > 0">
          تعداد کاربران ثبت نام کرده از تاریخ
          <span class="text-primary">
            {{ computedStartDate }}
          </span>
          تا تاریخ
          <span class="text-primary"> {{ computedEndDate }} </span>:
          <span> {{ valueArray[0] }} نفر </span>
        </div>
        <div v-if="valueArray && valueArray.length > 0">
          تعداد کاربران فعال از تاریخ
          <span class="text-primary">
            {{ computedStartDate }}
          </span>
          تا تاریخ
          <span class="text-primary"> {{ computedEndDate }} </span>:
          <span> {{ valueArray[1] }} نفر </span>
        </div>
        <!-- <b-card-text class="mb-0"> Last 6 months </b-card-text> -->
      </div>
    </b-card-header>
    <b-card-body>
      <vue-apex-charts
        v-if="isRenderingChart"
        type="radialBar"
        height="400"
        :options="chartOptions"
        :series="chartOptions.series"
      />
    </b-card-body>
  </b-card>
</template>
<script>
export default {
  props: {
    getChartData: {
      type: Function,
      required: true,
    },
  },
  watch: {
    dateRange: {
      handler(val) {
        this.getFreshData();
      },
    },
  },
  mounted() {
    let _this = this;
    this.getChartData(_this);
  },
  data() {
    return {
      dateRange: [],
      valueArray: [],
      chartOptions: {
        chart: {
          fontFamily: "IranSans",
        },
        series: [],
        plotOptions: {
          radialBar: {
            dataLabels: {
              value: {
                show: true,
                fontSize: "14px",
                fontFamily: undefined,
                fontWeight: 400,
                color: undefined,
                offsetY: 16,
                formatter: (val) => {
                  return ((val * this.valueArray[0]) / 100).toFixed(0) + " نفر";
                },
              },
              total: {
                show: true,
                label: "نرخ تبدیل سیستم",
                formatter: (w) => {
                  return (
                    ((this.valueArray[1] / this.valueArray[0]) * 100).toFixed(
                      2
                    ) + "%"
                  );
                },
              },
            },
          },
        },
        labels: ["کاربران ثبت نامی", "کاربران فعال"],
        colors: [
          "#a50000",
          "#005f96",
          "#00a53f",
          "#000000",
          "#5c0064",
          "#fa1db8ee",
        ],
      },
      chartPayload: {
        pageNumber: 1,
        count: 50,
      },
      isRenderingChart: true,
    };
  },
  methods: {
    getFreshData() {
      this.isRenderingChart = false;
      let _this = this;
      if (this.dateRange && this.dateRange.length == 0) {
        this.getChartData(_this);
      } else {
        this.getChartData(
          _this,
          new Date(this.dateRange[0]).toISOString(),
          new Date(this.dateRange[1]).toISOString()
        );
      }
      this.isRenderingChart = true;
    },
    clearDateRange() {
      this.dateRange = [];
    },
    renderChart() {
      this.isRenderingChart = true;
    },
  },
  computed: {
    computedStartDate() {
      if (this.dateRange && this.dateRange.length > 0) {
        return new Date(this.dateRange[0]).toLocaleDateString("fa-IR");
      } else {
        return new Date(new Date().getTime() - 2629746000).toLocaleDateString(
          "fa-IR"
        );
      }
    },
    computedEndDate() {
      if (this.dateRange && this.dateRange.length > 0) {
        return new Date(this.dateRange[1]).toLocaleDateString("fa-IR");
      } else {
        return new Date(new Date()).toLocaleDateString("fa-IR");
      }
    },
  },
  components: {
    VueApexCharts,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BCardText,
    BDropdown,
    BDropdownItem,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupText,
    BButton,
  },
};
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BCardText,
  BDropdown,
  BDropdownItem,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupText,
  BButton,
} from "bootstrap-vue";

import VueApexCharts from "vue-apexcharts";
</script>
